// source: pbtypes/gen/skills/gps_waypoint.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.skills.GpsWaypoint', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.GpsWaypoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.GpsWaypoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.GpsWaypoint.displayName = 'proto.skills.GpsWaypoint';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.GpsWaypoint.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.GpsWaypoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.GpsWaypoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.GpsWaypoint.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, 0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
hasAltitude: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
altitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
hasHeading: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
heading: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
hasGimbalPitch: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
gimbalPitch: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.GpsWaypoint}
 */
proto.skills.GpsWaypoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.GpsWaypoint;
  return proto.skills.GpsWaypoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.GpsWaypoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.GpsWaypoint}
 */
proto.skills.GpsWaypoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasAltitude(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAltitude(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasHeading(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeading(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasGimbalPitch(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalPitch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.GpsWaypoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.GpsWaypoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.GpsWaypoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.GpsWaypoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getHasAltitude();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getAltitude();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getHasHeading();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getHeading();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getHasGimbalPitch();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getGimbalPitch();
  if (f !== 0.0) {
    writer.writeFloat(
      9,
      f
    );
  }
};


/**
 * optional sint64 key = 1;
 * @return {number}
 */
proto.skills.GpsWaypoint.prototype.getKey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.GpsWaypoint} returns this
 */
proto.skills.GpsWaypoint.prototype.setKey = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double latitude = 2;
 * @return {number}
 */
proto.skills.GpsWaypoint.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.GpsWaypoint} returns this
 */
proto.skills.GpsWaypoint.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double longitude = 3;
 * @return {number}
 */
proto.skills.GpsWaypoint.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.GpsWaypoint} returns this
 */
proto.skills.GpsWaypoint.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional bool has_altitude = 4;
 * @return {boolean}
 */
proto.skills.GpsWaypoint.prototype.getHasAltitude = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.GpsWaypoint} returns this
 */
proto.skills.GpsWaypoint.prototype.setHasAltitude = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional double altitude = 5;
 * @return {number}
 */
proto.skills.GpsWaypoint.prototype.getAltitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.GpsWaypoint} returns this
 */
proto.skills.GpsWaypoint.prototype.setAltitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional bool has_heading = 6;
 * @return {boolean}
 */
proto.skills.GpsWaypoint.prototype.getHasHeading = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.GpsWaypoint} returns this
 */
proto.skills.GpsWaypoint.prototype.setHasHeading = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional float heading = 7;
 * @return {number}
 */
proto.skills.GpsWaypoint.prototype.getHeading = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.GpsWaypoint} returns this
 */
proto.skills.GpsWaypoint.prototype.setHeading = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional bool has_gimbal_pitch = 8;
 * @return {boolean}
 */
proto.skills.GpsWaypoint.prototype.getHasGimbalPitch = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.GpsWaypoint} returns this
 */
proto.skills.GpsWaypoint.prototype.setHasGimbalPitch = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional float gimbal_pitch = 9;
 * @return {number}
 */
proto.skills.GpsWaypoint.prototype.getGimbalPitch = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.GpsWaypoint} returns this
 */
proto.skills.GpsWaypoint.prototype.setGimbalPitch = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


goog.object.extend(exports, proto.skills);
